import PropTypes from "prop-types"
import Tooltip from "components/material/tooltip"
import { IconButton } from "@mui/material"
import { OpenInNew } from "@mui/icons-material"
import { Creators } from "model/compositeSecurity"
import { SECURITY } from "helpers/shapes"

const CompositeSecurityLink = ({ dispatch, account, security, modelId, analyzeCompositeAvailable }) => {
  const openCompositeSecurityTab = () => {
    dispatch(Creators.openCompositeSecurity(account, security, true, modelId))
  }

  const tooltip = analyzeCompositeAvailable ? "Analyze this composite security" : "Analyzing this composite security is not available with the selected model"

  return <Tooltip title={tooltip}>
    <span>
      <IconButton
        onClick={openCompositeSecurityTab}
        disabled={!analyzeCompositeAvailable}
        size="large"
      >
        <OpenInNew />
      </IconButton>
    </span>
  </Tooltip>
}

CompositeSecurityLink.propTypes = {
  dispatch: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  security: SECURITY.isRequired,
  modelId: PropTypes.string.isRequired,
  analyzeCompositeAvailable: PropTypes.bool.isRequired,
}

export default CompositeSecurityLink
